import Cookies from 'js-cookie';

export const initial = Cookies.getJSON();

export const update = (state, payload) => ({
    ...state,
    ...payload,
});
